import React, { Fragment } from "react";

export default (
  <>
    <path d="M5.9.3c-.5.5-.5 1.2 0 1.7l9.8 10-9.8 10c-.4.5-.4 1.2 0 1.7s1.2.5 1.6 0l10.6-10.8c.4-.5.4-1.2 0-1.7l-.1-.1s0-.1-.1-.1L7.5.3c-.4-.4-1.2-.4-1.6 0z" />
  </>
);
